import { DateTime } from "luxon";
import {
  BookingType,
  NotSerializedBookingInputs
} from "../../../features/Booking-Form/typings/booking-inputs";

const mapBookingInventoryIds = (inputs: NotSerializedBookingInputs) =>
  inputs.usersBookedFor?.map(user => user.bookingInventoryId ?? -1).filter(v => v >= 0);

export const modeWorkplace = (inputs: NotSerializedBookingInputs) => {
  const checkMode =
    inputs.mode === BookingType.WORKPLACE ||
    inputs.mode === BookingType.TEAM ||
    inputs.mode === BookingType.PARKINGPLACE ||
    inputs.mode === BookingType.ELECTRICCHARGINGSTATIONPLACE;

  return checkMode ? mapBookingInventoryIds(inputs) : undefined;
};

export const modeZone = (inputs: NotSerializedBookingInputs) =>
  inputs.mode === BookingType.PLACEZONE || inputs.mode === BookingType.CONFERENCEZONE
    ? mapBookingInventoryIds(inputs)
    : undefined;

export const modeVisitor = (inputs: NotSerializedBookingInputs) =>
  inputs.mode === BookingType.VISITOR ? mapBookingInventoryIds(inputs) : undefined;

export const handleDate = (
  date: DateTime,
  property: string,
  time: boolean,
  setConferenceInputs: any,
  open: any
) => {
  if (date && open.conference) {
    setConferenceInputs((prevState: any) => ({
      ...prevState,
      [property]: date.toFormat(time ? "HH:mm" : "yyyy-MM-dd")
    }));
  }
};
